import dayjs from 'dayjs';
import styles from './GridHeader.module.scss';

type GridHeaderMonthProps = {
  dateString: string;
  showLabel: boolean;
  widthPercent: number;
};

export const GridHeaderMonth = ({ dateString, showLabel, widthPercent }: GridHeaderMonthProps) => {
  const month = dayjs(dateString).startOf('day');

  return (
    <div className={styles['grid-header-month']} style={{ flexBasis: `${widthPercent}%` }}>
      {showLabel ? month.toDate().toLocaleString('default', { month: 'long' }) : ''}
    </div>
  );
};
